import axios from 'axios'

import { API_ROUTES, BASE_API_CONFIG } from '../../../utils/api'
export default {
  fetch(entity_type, entity_id) {
    return axios.request({
      ...BASE_API_CONFIG,
      method: 'GET',
      url: API_ROUTES.ads_banners,
      params: { entity_type: entity_type, entity_id: entity_id },
    })
  },
}
